import { AnalysisFeedbackResponse, AnalysisFeedbackSubmission } from '@futrli-sdk/predict_analysis';

export type AnalysisFeedbackRating = AnalysisFeedbackSubmission['rating'];

export type AnalysisFeedbackReasonCode = AnalysisFeedbackSubmission['reasons'][number];

export interface AnalysisFeedbackDraft {
  rating: AnalysisFeedbackRating | null;
  reasons: AnalysisFeedbackReasonCode[];
  comment: string;
}

export type AnalysisFeedbackRecord = AnalysisFeedbackResponse;

export type AnalysisFeedbackField = 'comment' | 'non_field_errors' | 'rating' | 'reasons';

export type AnalysisFeedbackFieldErrors = Partial<Record<AnalysisFeedbackField, string[]>>;

export type AnalysisFeedbackSaveResult =
  | { status: 'saved' }
  | { feedback: AnalysisFeedbackRecord; status: 'feedback_already_exists' }
  | { feedback: AnalysisFeedbackRecord; status: 'feedback_superseded' }
  | { status: 'stale_analysis' }
  | { status: 'forbidden' };

export class AnalysisFeedbackValidationError extends Error {
  public readonly fieldErrors: AnalysisFeedbackFieldErrors;

  public constructor(fieldErrors: AnalysisFeedbackFieldErrors) {
    super('Analysis feedback validation failed');
    Object.setPrototypeOf(this, AnalysisFeedbackValidationError.prototype);
    this.fieldErrors = fieldErrors;
    this.name = 'AnalysisFeedbackValidationError';
  }
}
